import { graphql, useStaticQuery } from 'gatsby'
import { useMedia } from 'react-use'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const BackgroundSmoke = () => {
  const data = useStaticQuery(graphql`
    query {
      backgroundMobile: file(
        relativePath: { eq: "layout/smoke-bg-mobile.png" }
      ) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [AUTO, WEBP], quality: 60)
        }
      }
      backgroundDesktop: file(relativePath: { eq: "layout/smoke-bg.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [AUTO, WEBP], quality: 60)
        }
      }
    }
  `)

  const isDesktop = useMedia('(min-width: 768px)', false)
  const isMobile = useMedia('(max-width: 767px)', false)

  return (
    <div className="absolute inset-0 -z-10 overflow-hidden">
      {isDesktop ? (
        <GatsbyImage
          image={getImage(data?.backgroundDesktop)}
          className="aspect-[985/4162] h-full w-full md:aspect-[4054/3122]"
          imgClassName="object-top object-cover w-full h-full"
          alt=""
        />
      ) : null}
      {isMobile ? (
        <GatsbyImage
          image={getImage(data?.backgroundMobile)}
          className="aspect-[985/4162] h-full w-full md:hidden"
          imgClassName="object-top object-cover w-full h-full"
          alt=""
        />
      ) : null}
    </div>
  )
}

export default BackgroundSmoke
